import {toggleSpinner, showToast} from "../global/utilities";

const cartPage = document.querySelector('.cart-page');

if (cartPage) {
    const removeFromCartBtns = cartPage.querySelectorAll('.remove-btn');
    const btns = cartPage.querySelectorAll('button');
    const total = cartPage.querySelector('.cart-total');
    const title = cartPage.querySelector('.cart-title');
    const table = cartPage.querySelector('table');
    const footer = cartPage.querySelector('.cart-page__footer');
    // const paymentBtn = cartPage.querySelector('.payment-btn');

    const removeProduct = (btn) => {
        const productId = btn.dataset.productId;

        toggleSpinner(btn, true);

        btns.forEach(_btn => {
            _btn.disabled = true;
        });

        jQuery.post(ajax_object.ajax_url, {
            action: 'remove_product_from_cart',
            productId: productId
        }, 'json')
            .done(function (data) {
                data = JSON.parse(data);

                if (data === '') {
                    showToast("Erreur lors de la suppression d'un article de votre panier.", 'error');
                } else if (data.success === false) {
                    showToast(data.message, 'error');

                    if (data.reload === true) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                } else {
                    total.innerText = data.total;
                    btn.closest('tr').remove();
                    showToast("Panier mis à jour avec succès.");
                }
            })
            .fail(function () {
                showToast("Erreur lors de la mise à jour du panier.", 'error');
            })
            .always(function (data, textStatus, jqXHR) {
                data = JSON.parse(data);
                console.log(data, textStatus, jqXHR);
                toggleSpinner(btn, false);

                btns.forEach(_btn => {
                    _btn.disabled = false;
                });

                if(data.total === 0) {
                    table.remove();
                    footer.remove();
                    title.innerText = 'Le panier est vide';
                    title.closest('h1').classList.add('empty-cart');
                }
            });
    };

    removeFromCartBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            removeProduct(btn);
        });
    });
}
